<div *ngIf="!groupPortalDataService.hideNavigation" class="container allmembers">
    <form>
        <!-- {{ groupPortalDataService.groupList.selectedMembers | json}} -->
        <div class="d-flex groupComponentHeading" *ngIf="groupPortalDataService.groupList.allMembers.length > 0">
            <div class="col d-flex flex-grow-1 members">All Members</div>
            <!-- <div class="col-2 filter FlowupLabels"> -->
            <div class="col-9 requestQuote d-flex justify-content-end headerButtons">
                <div class="col-4 d-flex filter">
                    <mat-form-field class="memberfilterdropdown">
                        <mat-select placeholder="" [(ngModel)]="memberFilterType" name="fMember" class="ddlmemberselect"
                            panelClass="mbrFilterPanel">
                            <mat-option *ngFor="let fMember of memberFilter" [value]="fMember.mfvalue"
                                class="ddlmemberselectoptions">
                                <span class="status{{fMember.mfvalue}}"></span>
                                <span class="statusLabel">{{ fMember.mftext }}</span>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- <div class="col-5 requestQuote d-flex justify-content-end headerButtons"> -->
                <button id="btnRequestQuote"
                    [disabled]="!groupPortalDataService.enableProcessPayment || !groupPortalDataService.inGroupBilling || groupPortalDataService.groupList.hasSubmittedStatus"
                    (click)="requestQuote()" class="btn btn-gpGray" title="Request Quote">Print Quote</button>
                <!-- </div>

				<div class="col-3 processPayment d-flex justify-content-end"> -->
                <button id="btnProcessPayment"
                    [disabled]="!groupPortalDataService.enableProcessPayment || !groupPortalDataService.inGroupBilling || groupPortalDataService.groupList.hasSubmittedStatus"
                    (click)="processPayment()" class="btn btn-gpPrimaryBlue" title="Process Payment">Go to
                    Checkout</button>
            </div>
        </div>
        <div class="result-grid container-fluid px-4">
            <div class="row headerRow-25">
                <div class="col-md-4 sort d-flex">
                    <div *ngIf="groupPortalDataService.inGroupBilling && !groupPortalDataService.groupList.hasSubmittedStatus"
                        class="checkbox c-checkbox needsclick">
                        <label class="needsclick">
                            <input class="needsclick" (change)="toggleMembers()" name="toggleMembers" id="toggleMembers"
                                type="checkbox" value="All" [disabled]="!groupPortalDataService.enableChkAllMembers"
                                [(ngModel)]="groupPortalDataService.chkAllMembers">
                            <span class="fa fa-check"></span>
                        </label>
                    </div>
                    <!-- </div>
                <div class="col-md-3 sort d-flex"> -->
                    <a class="{{groupPortalDataService.sortedBy == 'name' ? (groupPortalDataService.sortNameAscending ? 'sortAsc' : 'sortDesc') : 'sortArrow' }}"
                        (click)="changeSortName()"><strong>Name</strong></a>
                </div>
                <div class="col-md-2 sort d-flex">
                    <a class="{{groupPortalDataService.sortedBy == 'npi' ? (groupPortalDataService.sortNPIAscending ? 'sortAsc' : 'sortDesc') : 'sortArrow' }}"
                        (click)="changeSortNPI()"><strong>NPI</strong></a>
                </div>
                <div class="col-md-3 sort d-flex">
                    <a class="{{groupPortalDataService.sortedBy == 'status' ? (groupPortalDataService.sortStatusAscending ? 'sortAsc' : 'sortDesc') : 'sortArrow' }}"
                        (click)="changeSortStatus()"><strong>Status</strong></a>
                </div>
                <div class="col-md-2 sort d-flex justify-content-end pr-md-4">
                    <a *ngIf="groupPortalDataService.inGroupBilling"
                        class="{{groupPortalDataService.sortedBy == 'subtotal' ? (groupPortalDataService.sortSubtotalAscending ? 'sortAsc' : 'sortDesc') : 'sortArrow' }}"
                        (click)="changeSortSubtotal()"><strong>Subtotal</strong></a>
                </div>
                <div class="col-md-1 d-flex"></div>
            </div>
            <div class="row groupMembers py-3" *ngFor="let member of groupPortalDataService.groupList.allMembers"
                [hidden]="(member.status != memberFilterType && memberFilterType != '-1')">
                <div class="col-md-4 sort d-flex">
                    <div class="checkbox c-checkbox needsclick"
                        *ngIf="member.status == groupPortalDataService.statusCodeEnum.ReadyForPayment && !groupPortalDataService.groupList.hasSubmittedStatus">
                        <label class="needsclick">
                            <input class="needsclick" [(ngModel)]="member.AddToOrder" (change)="checkIfAllChecked()"
                                name="addToOrder member{{member.npi}}" id="addToOrder member{{member.npi}}"
                                type="checkbox" value="All">
                            <span class="fa fa-check"></span>
                        </label>
                    </div>
                    <!-- </div>
                <div class="col-md-3"> -->
                    <strong>{{member.formalName}}</strong>
                </div>
                <div class="col-md-2">
                    {{member.npi}}
                </div>
                <div class="col-md-3 member-status">
                    <div class="status{{member.statusLabel != null && member.statusLabel != '' ? member.status : ''}}">
                    </div>
                    <div class="statusLabel member-status-label">{{member.statusLabel}}</div>
                </div>
                <div class="col-md-2 sort d-flex justify-content-end pr-md-3">
                    <div class="mbrAmount " [hidden]="member.amount == null || member.amount == 0">
                        <div id="{{member.contactNo}}" class="{{member.contactNo}} collapsed"
                            (click)="showProducts(member.contactNo)">
                            <strong>{{member.amount | currency:'USD':'symbol-narrow':'1.2-2'}}</strong>
                            <!-- <span class="fa-stack"><i class="fa fa-circle fa-stack-2x"></i><i class="fa fa-chevron-down fa-stack-1x"></i></span> -->
                        </div>
                    </div>
                </div>
                <div class="col-md-1 dropdown"
                    *ngIf="!(groupPortalDataService.groupList.hasSubmittedStatus && (member.status != groupPortalDataService.statusCodeEnum.Paid))">
                    <!-- <img alt="Settings" class="dropbtn" src="assets/images/icon_images/settings.png" /> -->
                    <span class="mbrEditGear"></span>
                    <div class="dropdown-content arrow_box">
                        <a (click)="editContact(member)">Edit Contact</a>
                        <a (click)="resendInviteEmail(member)"
                            [hidden]="member.status != groupPortalDataService.statusCodeEnum.Pending || groupPortalDataService.groupList.GroupInfo?.residencyDetail">Resend
                            Invite Email</a>
                        <!-- (click)="sendInvite(member)" -->
                        <a *ngIf="groupPortalDataService.inGroupBilling"
                            (click)="RemoveFromGB(member)">{{member.isInGroupBilling ? 'Exclude from ' : 'Include in
                            '}}Group Bill</a>
                        <a *ngIf="!isResidencyGroupAdmin()" (click)="confirmRemoveParticipant(member,true)" title="Remove {{member.formalName}}">Remove
                            from Group</a>
                    </div>
                </div>
                <div class="container-fluid mbrProducts products{{member.contactNo}}" style="display:none">
                    <div class="row" *ngFor="let product of member.OrderLineItems">
                        <div class="col-md-9">
                            <div class="checkbox c-checkbox needsclick checkboxhide">
                                <label class="needsclick">
                                    <input class="needsclick" type="checkbox" value="blank" disabled="disabled">
                                    <span class="fa fa-check"></span>
                                </label>
                            </div>
                            <span>{{product.productName}}</span>
                        </div>
                        <div class="mbrProductAmtHidden col-md-2 sort d-flex justify-content-end pr-md-3">
                            <span>{{product.extendedAmount | currency:'USD':'symbol-narrow':'1.2-2'}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row groupMembers py-3" *ngIf="groupPortalDataService.groupList.allMembers.length < 1">
                <div class="col-md-12 sort d-flex">
                    <i>Currently no members to display.</i>
                </div>
            </div>
            <div class="row groupComponentHeading"
                *ngIf="groupPortalDataService.groupList.allMembers.length > 0 && groupPortalDataService.inGroupBilling">
                <div class="col d-flex flex-grow-9 members">{{ groupPortalDataService.groupList.hasSubmittedStatus ?
                    groupPortalDataService.groupList.submittedMemberCount :
                    groupPortalDataService.groupList.selectedMembers.length}} Applicants</div>
                <div class="col-3 d-flex justify-content-end members">
                    Total {{groupPortalDataService.groupList.selectedAmount | currency:'USD':'symbol-narrow':'1.2-2'}}
                </div>
            </div>

            <div class="row groupComponentHeading" *ngIf="groupPortalDataService.groupList.allMembers.length > 0">
                <div class="col-6 d-flex flex-grow-1">
                    <span class="d-flex"
                        *ngIf="groupPortalDataService.groupList.hasSubmittedStatus && groupPortalDataService.groupList.selectedGroup.role == 'Group Administrator Staff'">
                        <button id="btnRecall" *ngIf="groupPortalDataService.groupList.outstandingTotal > 0"
                            class="btn btn-gpGray" title="Recall Payment"
                            (click)="confirmRecallPayment()">Recall</button>
                        <button id="btnApplyPayment" *ngIf="groupPortalDataService.groupList.outstandingTotal > 0"
                            class="btn btn-gpGray" title="Apply Payment" (click)="confirmApplyPayment()">Apply
                            Payment</button>
                        <span *ngIf="groupPortalDataService.groupList.outstandingTotal > 0"
                            class="outstanding-amount">Outstanding Total <br>
                            {{groupPortalDataService.groupList.outstandingTotal |
                            currency:'USD':'symbol-narrow':'1.2-2'}}</span>
                        <span *ngIf="groupPortalDataService.groupList.outstandingTotal <= 0">Group bill is being
                            processed, please refresh </span>
                    </span>
                </div>
                <!-- <div class="col-2 filter FlowupLabels"> -->
                <div class="col-6 requestQuote d-flex justify-content-end headerButtons">
                    <!-- <div class="col-5 requestQuote d-flex justify-content-end headerButtons"> -->
                    <button id="btnRequestQuoteBottom"
                        [disabled]="!groupPortalDataService.enableProcessPayment || !groupPortalDataService.inGroupBilling || groupPortalDataService.groupList.hasSubmittedStatus"
                        (click)="requestQuote()" class="btn btn-gpGray" title="Request Quote">Print Quote</button>
                    <!-- </div>

						<div class="col-3 processPayment d-flex justify-content-end"> -->
                    <button id="btnProcessPaymentBottom"
                        [disabled]="!groupPortalDataService.enableProcessPayment || !groupPortalDataService.inGroupBilling || groupPortalDataService.groupList.hasSubmittedStatus"
                        (click)="processPayment()" class="btn btn-gpPrimaryBlue" title="Process Payment">Go to
                        Checkout</button>
                </div>
            </div>
            <div class="remodal groupComponentHeading" data-remodal-id="deleteParticipant">
                <div>Are you sure you want to {{removeMode? 'remove' : 'resend the invite email to'}} the member -
                    <br>{{selectedMember?.formalName}}?
                </div>
                <div class="font-italic modal-info"
                    *ngIf="groupPortalDataService.groupList.GroupInfo?.residencyDetail && removeMode">
                    A resident should only be removed from a program for reasons besides graduation.<br><br>Do you wish
                    to continue?
                </div>
                <!-- <div class="div-padding-bottom-40"></div> -->
                <button data-remodal-action="cancel" id="btnModalCancel" title="NO, Do not remove from group"
                    class="btn btn-gpGray float-left" (click)="cancelModal()">Cancel</button>
                <button data-remodal-action="confirm" id="btnModalConfirm" title="YES, Remove from group"
                    class="btn btn-gpPrimaryBlue float-right" (click)="memberAction()">Continue</button>
            </div>
            <div class="remodal groupComponentHeading recall-apply-popup" data-remodal-id="recallPayment">
                <div class="float-left">
                    <h3 class="warning-red-color">Are you sure?</h3>
                </div>
                <div class="float-right dialog-close" (click)="cancelModal()">
                    <h3 class="dialog-close-color">X</h3>
                </div>
                <br>
                <div class="float-left popup-text" *ngIf="recallPayment">
                    This process will undo the setup for the currently pending group bill. The Group Bill Number ({{
                    groupPortalDataService.groupList.submittedGBN }}) will be cancelled and all members' statuses will
                    be reset.
                </div>
                <div class="float-left popup-text" *ngIf="!recallPayment">
                    Please confirm with Finance payment amount received matches group bill amount. <br><br>Once payment
                    is applied, recall is <b class="warning-red-color">not available</b>.
                </div>

                <!-- <div class="div-padding-bottom-40"></div> -->
                <div>
                    <button data-remodal-action="cancel" id="btnModalCancel" title="Cancel"
                        class="btn btn-border-gpGray popup-button float-left col-md-6 col-md-12 col-sm-12 my-md-1 my-sm-1"
                        (click)="cancelModal()">Cancel</button>
                    <button *ngIf="recallPayment" data-remodal-action="confirm" id="btnModalRecall"
                        title="YES, recall the payment"
                        class="btn btn-gpredwarning popup-button float-right col-md-6 col-md-12 col-sm-12 my-md-1 my-sm-1"
                        (click)="callRecallApplyPayment(true)">Recall</button>
                    <button *ngIf="!recallPayment" data-remodal-action="confirm" id="btnModalApply"
                        title="YES, apply the payment"
                        class="btn btn-gpredwarning popup-button float-right col-md-12 col-sm-12 my-md-1 my-sm-1"
                        (click)="callRecallApplyPayment(false)">Apply Payment</button>
                </div>
            </div>
        </div>
        <div hidden><button id="btnRequestQuote2" [disabled]="!groupPortalDataService.enableProcessPayment"
                (click)="printElem()" class="btn btn-gpGray" title="Request Quote">Print Quote</button></div>
        <!-- THIS IS THE PRINT QUOTE TEST HTML -->
        <!-- <link rel="stylesheet" type="text/css" href="./assets/styles/quotestyles.css"> -->

        <!-- hidden -->
        <div id="body" hidden>
            <div id="quoteHtml" class="quoteHtml">
                <table class="report-container">
                    <thead class="report-header">
                        <tr>
                            <th class="report-header-cell newheader">
                                <div class="flexedheader forlogos">
                                    <div class="logorow">
                                        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid !== 'Yes' &&
										groupPortalDataService.groupList.GroupInfo?.category != 'Residency'" class="aceplogo">
                                            <img src="https://www.acep.org/globalassets/sites/acep/media/global/acep-logo3x.png"
                                                title="ACEP">
                                        </div>
                                        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid == 'Yes'"
                                            class="aceplogo">
                                            <img src="https://acep-assets.s3.amazonaws.com/global/LOGO_SEMPA_H50.png"
                                                title="SEMPA">
                                        </div>
                                        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.category == 'Residency'"
                                            class="emralogo">
                                            <img src="https://www.emra.org/globalassets/emra/images/emra-logo.png"
                                                title="EMRA">
                                        </div>
                                    </div>
                                </div>
                                <div class="flexedheader forcontactquote">
                                    <div class="contactquoterow">
                                        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid !== 'Yes'"
                                            class="contact">
                                            <span>T: 800-798-1822 F:972-534-1579 <a
                                                    href="https://www.acep.org">www.acep.org</a></span>
                                        </div>
                                        <div *ngIf="groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid == 'Yes'"
                                            class="contact">
                                            <span>T: 844-381-0911 F: 972-999-4624 <a
                                                    href="https://www.sempa.org">www.sempa.org</a></span>
                                        </div>
                                        <div class="qQuote"><span><strong>Quote - Do Not Pay</strong></span></div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>

                    <tfoot class="report-footer">
                        <tr>
                            <th class="report-footer-cell">
                                <div *ngIf="groupPortalDataService.groupList.GroupInfo?.category != 'Residency' && groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid !== 'Yes'"
                                    class="footer-info emgroup">
                                    Questions? Please contact emgroups@acep.org. Thank you.
                                </div>
                                <div *ngIf="groupPortalDataService.groupList.GroupInfo?.physgrpDetail?.sempaDuesPaid == 'Yes'"
                                    class="footer-info emgroup">
                                    Questions? Please contact sempagroupbilling@acep.org. Thank you.
                                </div>
                                <div *ngIf="groupPortalDataService.groupList.GroupInfo?.category == 'Residency'"
                                    class="footer-info residents">
                                    Questions? Please contact residencies@acep.org. Thank you.
                                </div>
                            </th>
                        </tr>
                    </tfoot>
                    <tbody class="report-content">
                        <tr>
                            <td class="report-content-cell">
                                <div class="main">
                                    <table class="qCustomerInfo">
                                        <tr>
                                            <td class="qCustAddr">
                                                {{groupPortalDataService.groupList.GroupInfo?.accountNo}}<br>
                                                <b>{{groupPortalDataService.groupList.GroupInfo?.name}}</b><br>
                                                {{groupPortalDataService.groupList.GroupInfo?.street}}
                                                <br> {{groupPortalDataService.groupList.GroupInfo?.city}},
                                                {{groupPortalDataService.groupList.GroupInfo?.state}}
                                                {{groupPortalDataService.groupList.GroupInfo?.zip}}
                                                <br> T: {{groupPortalDataService.groupList.GroupInfo?.mainPhone}}
                                            </td>
                                            <td class="qTermsGrid">
                                                <table class="table tbl-amounts">
                                                    <tr>
                                                        <td class="text-nowrap">Due
                                                            Date<br>{{groupPortalDataService.headerInfo.dueDate}}</td>
                                                        <td class="text-nowrap" colspan="2">Amount
                                                            Due<br>{{groupPortalDataService.groupList.selectedAmount |
                                                            currency:'USD':'symbol-narrow':'1.2-2'}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2" style="border: none;"><b
                                                                style="margin-top: 0px; float: left;">Group Term:
                                                                {{groupPortalDataService.groupList.GroupInfo?.residencyDetail
                                                                ?
                                                                SantizeDate(groupPortalDataService.groupList.GroupInfo?.residencyDetail.cycleStartDate)
                                                                :
                                                                SantizeDate(groupPortalDataService.groupList.GroupInfo?.physgrpDetail.cycleStartDate)}}
                                                                -
                                                                {{groupPortalDataService.groupList.GroupInfo?.residencyDetail
                                                                ?
                                                                SantizeDate(groupPortalDataService.groupList.GroupInfo?.residencyDetail.expirationDate)
                                                                :
                                                                SantizeDate(groupPortalDataService.groupList.GroupInfo?.physgrpDetail.expirationDate)}}</b>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>

                                    <div class="qGridResults result-grid">
                                        <table class="table tbl-grid" border="0"
                                            *ngIf="!groupPortalDataService.groupList.GroupInfo?.residencyDetail">
                                            <tr
                                                *ngFor="let member of filterGroupMembers(groupPortalDataService.groupList.selectedMembers); let i=index ">
                                                <td>
                                                    <table class="table tbl-rowdata " border="0 ">
                                                        <thead *ngIf="i==0 " [ngClass]="{ 'subtablesubheader': i> 0}">
                                                            <tr class="table-primary">
                                                                <th scope="col" class="text-nowrap acepidcol">Account ID
                                                                </th>
                                                                <th scope="col" class="text-nowrap namecol">Name</th>
                                                                <th scope="col" class="text-nowrap typecol">
                                                                    <span>Type</span> | <span>Rate</span>
                                                                </th>
                                                                <th scope="col" class="amountcell text-nowrap">Amount
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tr class="blue-row">
                                                            <td class="dataacepid">
                                                                <strong>{{member.contactNo}}</strong>
                                                            </td>
                                                            <td class="datanamecol">
                                                                {{member.formalName}}
                                                            </td>
                                                            <td class="datatypecol">
                                                                <span>{{member.memberType}}</span> |
                                                                <span>{{member.memberRate}}</span>
                                                            </td>
                                                            <td class="amountcell">
                                                                <div class="mbrAmount" [hidden]="member.amount == 0">
                                                                    <strong>{{member.amount |
                                                                        currency:'USD':'symbol-narrow':'1.2-2'}}</strong>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr class="nested-row"
                                                            *ngFor="let product of member.OrderLineItems">
                                                            <td class="subblank"></td>
                                                            <td colspan="2" class="subdoubleup">
                                                                {{product.productName}}
                                                            </td>
                                                            <td class="amountcell">
                                                                <span>{{product.extendedAmount |
                                                                    currency:'USD':'symbol-narrow':'1.2-2'}}</span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                        <!-- Residency Invoice -->

                                        <table class="table tbl-grid" border="0"
                                            *ngIf="groupPortalDataService.groupList.GroupInfo?.residencyDetail">
                                            <tr
                                                *ngFor="let yearGroup of groupPortalDataService.groupList.ResidentInvoiceData; let i = index">
                                                <td>
                                                    <table class="table tbl-rowdata" border="0">
                                                        <thead *ngIf="i == 0" [ngClass]="{'subtablesubheader': i > 0}">
                                                            <tr class="table-primary">
                                                                <th scope="col" class="text-nowrap gradyearcol">Grad
                                                                    Year</th>
                                                                <th scope="col" class="text-nowrap acepidcol">ACEP ID
                                                                </th>
                                                                <th scope="col" class="text-nowrap namecol">Name</th>
                                                                <th scope="col" class="text-nowrap typecol">
                                                                    <span>Type</span> | <span>Rate</span>
                                                                </th>
                                                                <th scope="col" class="amountcell text-nowrap">Amount
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tr class="blue-row">
                                                            <td class="datagradyear">
                                                                <strong>{{yearGroup?.gradYear}}</strong>
                                                            </td>
                                                            <td class="dataacepid">
                                                            </td>
                                                            <td class="datanamecol">
                                                            </td>
                                                            <td class="datatypecol">
                                                            </td>
                                                            <td class="amountcell">

                                                            </td>
                                                        </tr>
                                                        <tr
                                                            *ngFor="let member of filterGroupMembers(yearGroup?.yearMembers); let m = index">
                                                            <td colspan="5">
                                                                <table class="table tbl-rowdata" border="0">
                                                                    <tr class="blue-row">
                                                                        <td class="datagradyear">
                                                                        </td>
                                                                        <td class="dataacepid">
                                                                            <strong>{{member.contactNo}}</strong>
                                                                        </td>
                                                                        <td class="datanamecol">
                                                                            {{member.formalName}}
                                                                        </td>
                                                                        <td class="datatypecol">
                                                                            <span>{{member.memberType}}</span> |
                                                                            <span>{{member.memberRate}}</span>
                                                                        </td>
                                                                        <td class="amountcell">
                                                                            <div class="mbrAmount"
                                                                                [hidden]="member.amount == 0">
                                                                                <strong>{{member.amount |
                                                                                    currency:'USD':'symbol-narrow':'1.2-2'}}</strong>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr class="nested-row"
                                                                        *ngFor="let product of member.OrderLineItems">
                                                                        <td class="subblank"></td>
                                                                        <td colspan="2" class="subdoubleup">
                                                                            {{product.productName}}
                                                                        </td>
                                                                        <td class="amountcell">
                                                                            <span>{{product.extendedAmount |
                                                                                currency:'USD':'symbol-narrow':'1.2-2'}}</span>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                        <div>
                                            <p style="float: left;">
                                                <b>{{groupPortalDataService.groupList.selectedMembers.length}} Members
                                                    on Invoice</b></p>
                                            <p style="float: right;"><b>Invoice Total is
                                                    {{groupPortalDataService.groupList.selectedAmount |
                                                    currency:'USD':'symbol-narrow':'1.2-2'}}</b></p>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </form>
</div>
<div *ngIf="groupPortalDataService.hideNavigation" class="apply-payment">
    <app-apply-payment [poNumber]="groupPortalDataService.purchaseOrderNo"
        [groupBillNo]="groupPortalDataService.groupList.submittedGBN"
        [amount]="groupPortalDataService.totalAmountCharged"
        [totalMember]="groupPortalDataService.groupList.submittedMemberCount"></app-apply-payment>
    <button class="btn btn-gpPrimaryBlue float-right" id="btnBackAllMembers" (click)="retunToAllMembers()">Back to All
        Members</button>
</div>

<div class="componentLoader "
    [ngClass]="{'hidethis': groupPortalDataService.showChart && !groupPortalDataService.showLoader}"></div>